// Na produkcji zapytania przechodzą przez nginx na krawodev.pl, dzięki czemu
// przeglądarka nie wykonuje żądania cross-origin do API ZTM.
const ZTM_API_BASE = process.env.REACT_APP_ZTM_API_BASE || (
  process.env.NODE_ENV === 'production'
    ? '/odjazdy/api/ztm'
    : 'https://ckan2.multimediagdansk.pl'
);

export default ZTM_API_BASE;
